import { Component, OnInit } from '@angular/core';
import { SeoService } from '../../../services/seo.service';

@Component({
  selector: 'app-windows-cloud',
  templateUrl: './windows-cloud.component.html',
  styleUrls: ['./windows-cloud.component.css']
})
export class WindowsCloudComponent implements OnInit {

  constructor(private seoService: SeoService) { }

  ngOnInit(): void {
    this.seoService.setSEOTags(
      'Windows Cloud Hosting',
      'Premium Windows Cloud Hosting in India with high-performance virtual machines, scalable resources, and enterprise-grade security. Perfect for businesses of all sizes with 24/7 support and 99.9% uptime SLA.',
      'Windows Cloud Hosting India, Windows VPS India, Cloud Windows Server, Virtual Windows Machine, Enterprise Cloud Solutions, Scalable Cloud Hosting, Cloud Infrastructure India'
    );
  }

}
